import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const userId = sessionStorage.getItem("user_id");
  const location = useLocation();

  // Prevent redirect loop: only redirect if not on login page
  if (!userId && location.pathname !== "/") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
